
import request from '../request'
import apis from '../apis'
export default {
// 获取预订人信息
    getPesonInfo(params) {
        return request.get(apis.GET_FINGUSERINFO, params)
    },
    getCarRules(params) {
        return request.post(apis.GET_CARRULE, params)
    },
    // 弱提示
    getReceiveSign(params) {
        return request.get(`${apis.GET_RECEIVE_SIGN}?exhiId=${params.exhiId}&tipType=1`)
    },
    submitWelocomeOrder(params) {
        return request.post(apis.SUBMIT_VEHICLE_WELCOMEORDER, params)
    },
    submitSendoffOrder(params) {
        return request.post(apis.SUBMIT_VEHICLE_SENDOFFORDER, params)
    },
    updateWelocomeOrder(params) {
        return request.post(apis.UPDATE_VEHICLE_WELCOMEORDER, params)
    },
    updateSendoffOrder(params) {
        return request.post(apis.UPDATE_VEHICLE_SENDOFFORDER, params)
    },
    findVehGroupInfoList(params) {
        return request.get(apis.GET_VEH_GROUPLIST, params)
    },
    findVehPlaceList(params) {
        return request.get(apis.GET_VEH_PLACELIST, params)
    },
    getVehicleLookUp(params) {
        return request.get(apis.GET_VEH_LOOKUP, { params });
    },
    getVehicleLockInfo(params) {
        return request.get(apis.GET_VEHICLE_LOCKINFO, { params });
    },
    remoteValidLock(params) {
        return request.post(apis.VALID_VEHICLE_LOCK, params)
    },
    remoteValidDate(params) {
        return request.post(apis.VALID_VEHICLE_DATE, params)
    },
    remoteValidGroup(params) {
        return request.post(apis.VALIDE_VEHICLE_GROUP, params)
    },
    getVehicleHotQaList({ lang }) {
        return request.get(apis.GET_VEH_QALIST.replace('{lang}', lang))
    },
    findVehrderPagedList({ pageVO, params }) {
        return request.get(`${apis.GET_VEH_FIND_ORDER_PAGED_LIST}/${pageVO.pageSize}/${pageVO.curPage}`, { params: params });
    },
    findVehOrderDetail(params) {
        return request.get(apis.GET_VEH_ORDER_DETAIL, params)
    },
    findVehCarDriverList(params) {
        return request.get(apis.GET_VEH_CAR_DRIVER_LIST, params)
    },
    cancelVehOrder(params) {
        return request.put(apis.CANCEL_VEH_ORDER, params)
    },
    findReceiveClassesInfo(params) {
        return request.get(apis.GET_CALSSESINFO + params.receiveClasses)
    },
    // 获取车辆取消规则接口
    getVehRuleSer(params) {
        return request.get(apis.GET_VEH_RULE, { params });
    },
    // 押车预定车型服务接口
    getVehTypeList(params) {
        return request.get(apis.GET_VEH_TYPE_LIST, { params });
    },
    // 商旅用车列表服务接口
    getVehList(params) {
        return request.post(`${apis.GET_VEH_LIST}/${params.pageVO.pageSize}/${params.pageVO.curPage}`, params.params)
    },
    // 提供修改订单查询订单详情
    getVehOrderEditSer(params) {
        return request.post(apis.GET_VEH_ORDER_EDIT, params)
    },
    // 用车时间列表服务接口
    getVehTimeDate(params) {
        return request.get(apis.GET_VEH_TIME_DATE, { params });
    },
    // 订单团组相关的热门酒店列表服务接口
    getVehHotHotel(params) {
        return request.get(apis.GET_VEH_HOT_HOTEL, { params });
    },
    // 订单列表查询服务接口
    getVehOrderPageList(params) {
        return request.post(apis.GET_VEH_ORDER_PAGE_LIST, params)
    },
    // 提交车辆预定服务接口
    getVehOrderSubmitSer(params) {
        return request.post(apis.GET_VEH_OTDER_SUBMIT, params)
    },
    // 查询人员信息接口
    getVehInfoSer(params) {
        return request.get(apis.GET_VEH_INFO, { params });
    },
    // 订单保存服务接口
    getVehOrderSave(params) {
        return request.post(apis.GET_VEH_OTDER_SAVE, params)
    },
    // 车辆订单编辑服务
    getVehOrderByEditSer(params) {
        return request.get(apis.GET_VEH_ORDER_BY_EDIT, { params });
    },
    // 车辆订单取消服务
    getVehOrderCancelSer(params) {
        return request.post(apis.GET_VEH_OTDER_CANCEL, params)
    },
    getEMSGroupNoListSer(params) {
        return request.get(apis.GET_VEH_EMS_GROUP_LIST, { params });
    },
    // 查询mrs团组信息soa接口
    getVehMgrGroupListSer(params) {
        return request.get(apis.GET_VEH_MGR_GROUP_LIST, { params });
    },
    // 查询icims团组信息soa接口
    getVehIcimGroupListSer(params) {
        return request.get(apis.GET_VEH_ICIM_GROUP_LIST, { params });
    },

    // 用车申请日志查询
    getVehLogSer(params) {
        return request.post(apis.GET_VEH_LOG, params)
    },
    // 根据车型查询时长
    getVehFindTimeSer(params) {
        return request.get(apis.GET_VEH_FIND_TIME, { params });
    },
    // 用车申请费用查询列表
    getVehFeeCalSer(params) {
        return request.post(apis.GET_VEH_FEECAL, params)
    },
    // 用车列表富文本查询
    getVehTravelSer(params) {
        return request.get(`${apis.GET_VEH_TRAVEL}/${params.lang}/true`)
    },
    // 用车列表富文本查询
    getVehFindDurationSer(params) {
        return request.get(apis.GET_VEH_FIND_DURATION, { params });
    },
    // 根据押车用途查询车型列表
    getVehSelectionSer(params) {
        return request.get(apis.GET_VEH_SELECTION, { params });
    },
    // 提供根据时间判断所选车型余量是否充足服务
    getVehMarginJudSer(params) {
        return request.get(apis.GET_VEH_MARGIN_JUD, { params });
    }
}
